import { Order } from '@features/siteStatusV2/types';
import React, { useEffect, useState } from 'react';
import { Container, Row } from 'react-bootstrap';

import { useAppDispatch } from '../../../../app/hooks';
import { resetOrderList } from '../../reducer/orderListSlice';
import OrderDetailsSwitcher from './OrderDetailsSwitcher';
import OrderList from './OrderList';

const Orders: React.FC = () => {
  const dispatch = useAppDispatch();
  const [orderSelected, setOrderSelected] = useState<Order | undefined>(undefined);
  useEffect(() => {
    return () => {
      dispatch(resetOrderList());
    };
  }, [dispatch]);

  return (
    <Container fluid className="mt-3 p-0">
      <Row>
        <OrderList orderSelected={orderSelected} setOrderSelected={setOrderSelected} />
        <OrderDetailsSwitcher order={orderSelected} />
      </Row>
    </Container>
  );
};

export default Orders;
